const traceHeadIcon = (color: string, rotation: number | undefined) => {
  const svg = `
      <svg xmlns="http://www.w3.org/2000/svg" fill="${color}" width="800px" height="800px" viewBox="0 0 24 24"  style="transform: rotate(${rotation ?? 0}deg); transform-origin: center;">
        <g data-name="Layer 2">
          <g data-name="navigation">
            <rect width="24" height="24" opacity="0"/>
              <path d="M20 20a.94.94 0 0 1-.55-.17l-6.9-4.56a1 1 0 0 0-1.1 0l-6.9 4.56a1 1 0 0 1-1.44-1.28l8-16a1 1 0 0 1 1.78 0l8 16a1 1 0 0 1-.23 1.2A1 1 0 0 1 20 20z"/>
          </g>
        </g>
      </svg>`;

  const encodedSvg = btoa(svg);
  return `data:image/svg+xml;base64,${encodedSvg}`;
};

export default traceHeadIcon;
